
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  ref,
  nextTick,
} from "vue";
import { apiSearchCommunity } from "@api/gamelibs";
import { useRouter, useRoute } from "vue-router";
import { useloginStore } from "@/store/login";
import type, { Popover, SelectProps, message } from "ant-design-vue";
import { debounce } from "@js/utils";
import type { yunpb } from "@/types/protobuf";
import { storeToRefs } from "pinia";
import { formatDatetime } from "@js/utils";
import i18n from "@/i18n";
import { uselangStore } from "@/store/lang";
import { useLayoutDataStore } from "@/store/layoutData";
import { trackCustomizeEvent } from "@/js/stastic";
// 路由tab
// const navTabList = [
//   {
//     label: "Game Library",
//     name: "GameLibrary",
//     id: 0,
//   },
//   {
//     label: "DownLoad",
//     name: "DownLoad",
//     id: 1,
//   },
// ];
const navTabList = [
  {
    get label() {
      return i18n.global.t("Header.gameLibrary");
    },
    name: "GameLibrary",
    id: 0,
    bgColor: "rgba(17, 17, 17, 1)",
    searchBgColor: "1f1f1f",
    tabColor: "rgba(255, 255, 255, 0.45)",
    assetsBoxBg: "#1f1f1f",
    index: 0,
  },
  {
    label: "VIP",
    name: "VIP",
    id: 2,
    icon: require("@/assets/img/tab_icon_vip.svg"),
    // bgColor: "#301449",
    bgColor: "transparent",
    searchBgColor: "rgba(255, 255, 255, 0.06)",
    assetsBoxBg: "rgba(255, 255, 255, 0.06)",
    index: 1,
  },
  {
    get label() {
      return i18n.global.t("Header.downLoad");
    },
    name: "DownLoad",
    id: 1,
    bgColor: "transparent",
    searchBgColor: "1f1f1f",
    assetsBoxBg: "#1f1f1f",
    index: 2,
  },
  {
    get label() {
      return i18n.global.t("Header.gameShare");
    },
    name: "GameShare",
    id: 3,
    bgColor: "transparent",
    searchBgColor: "1f1f1f",
    assetsBoxBg: "#1f1f1f",
    index: 3,
  },
];

interface langObj {
  label: string;
  value: string;
  id: number;
}

interface CountryOption {
  icon: string;
  value: string;
  label: string;
}

const countries = ref<CountryOption[]>([
  {
    icon: "英语icon",
    value: "en",
    label: "English",
  },
  {
    icon: "葡萄牙语icon",
    value: "pt",
    label: "Português",
  },
  {
    icon: "泰语icon",
    value: "th",
    label: "ไทย",
  },
  {
    icon: "印尼语icon",
    value: "id",
    label: "Indonesia",
  },
  {
    icon: "越南语icon",
    value: "vi",
    label: "Tiếng Việt",
  },
  {
    icon: "繁体icon",
    value: "zh",
    label: "中文繁体",
  },
]);

interface IGameLibraryCommunity extends yunpb.IGameLibraryCommunity {
  matchName?: string;
}

interface IRreactive {
  searchIpt: string;
  searchIptDom: any;
  avatarPopover: any;
  isIptFocus: boolean;
  communityList: IGameLibraryCommunity[];
  // 选中的关键字
  selectKeyWord: string;
}
export default defineComponent({
  props: {
    bgColor: String,
    currentTab: Number,
    tabColor: String,
  },
  components: {
    Popover,
  },
  name: "AppHeader",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const loginStore = useloginStore();
    const layoutDataStore = useLayoutDataStore();
    const { isSignIn, userInfo, golds, gems } = storeToRefs(loginStore);
    const { purchasedGamesData } = storeToRefs(layoutDataStore);
    const data = reactive<IRreactive>({
      searchIpt: (route.query.search as string) || "",
      searchIptDom: null,
      avatarPopover: null,
      isIptFocus: false,
      communityList: [],
      selectKeyWord: "",
    });
    // 何时可见搜索框
    const canShowSearchIpt = computed(() => {
      const hideRouteName = ["DownLoad", "GameShare"];
      return !hideRouteName.includes(route.name as string);
    });

    const handleOpenPurchasedGame = () => {
      if (!purchasedGamesData.value.length) {
        message.info("no game purchased");
        return;
      }
      layoutDataStore.updateStateProp("purchasedGameModal", true);
      trackCustomizeEvent({
        event_id: "chikiiweb-purchasedGame-click",
      });
    };
    // 搜索框获得焦点
    const handleSearchIptFocus = () => {
      console.log("获得焦点");
      data.isIptFocus = true;
      data.searchIptDom.focus();
      searchByInput(data.searchIpt);
    };

    const vipExpireTime = computed(() => {
      const d = formatDatetime(userInfo.value.vipInfo?.expireAt * 1000);
      return `${d.year}.${d.month}.${d.day}`;
    });
    // 退出登录
    const handlerLoginout = () => {
      loginStore.chikiiLoginOut();
    };
    // 登录
    const handlerLogin = () => {
      loginStore.setIsModalVisable(true);
    };
    const currentNav = computed(() => {
      const res = navTabList.find((nav: any) => nav.name === route.name);
      if (res) {
        transLength(res.index);
      }
      return res;
    });
    const navTransLen = ref(0);
    const transLength = (idx: number) => {
      let currentIdx: any = currentNav.value?.index;
      console.log("YUYA", navLenObj.value);
      if (!navTransLen.value) {
        // 兼容初始值的问题  减去8是横条长度的一半
        if (currentIdx !== 0) {
          navTransLen.value =
            navTransLen.value + navLenObj.value.get(0)
              ? navLenObj.value.get(0) / 2 - 8
              : 0;
        } else {
          navTransLen.value = -8;
        }
        currentIdx = 0;
      }
      const targetIdx = idx;
      if (targetIdx === currentIdx && !isInitPage.value) {
        // 当前和目标一致 第一次进入页面除外 原因：初始化的时候默认位置已经移动了
        return;
      }
      const needLen = Array.from(navLenObj.value)
        .filter(([key]) => {
          if (targetIdx > currentIdx) {
            return key >= currentIdx && key <= targetIdx;
          } else {
            return key <= currentIdx && key >= targetIdx;
          }
        })
        .reduce((totalLen, [key, thisWidth]) => {
          return (
            totalLen +
            (key === currentIdx || key === targetIdx
              ? thisWidth / 2
              : thisWidth)
          );
        }, 0);
      navTransLen.value =
        navTransLen.value + (targetIdx >= currentIdx ? needLen : -needLen);
      console.log("kkk", navTransLen.value, targetIdx, currentIdx, needLen);
    };

    // 切换顶部的路由tab
    const changeNavTab = (name: string, idx: number) => {
      if (idx === currentNav.value?.index) {
        return;
      }
      if (!currentNav.value) {
        //处理跳转到其他页面的问题
        navTransLen.value = 0;
      }
      isInitPage.value = false;
      router.push({ name });
    };
    // 打开充值弹窗
    const openRecharge = () => {
      console.log("openRecharge");
      loginStore.update_isShowRecharge(true);
    };

    // 输入时的搜索
    const searchByInput = debounce(async (val: string) => {
      console.log("searchByInput", val);
      try {
        // 没有输入时清空关键字候选列表
        if (!val) {
          data.selectKeyWord = "";
          data.communityList.length = 0;
          return;
        }
        const res = await apiSearchCommunity({
          searchMsg: val,
          filterType: 1,
          page: 1,
          pageSize: 6,
        });
        const reg = new RegExp(val, "gi");
        data.communityList = res.webCommunitySearchList!.map(
          (item: IGameLibraryCommunity) => {
            item.matchName = item.name?.replace(reg, (matchWord: string) => {
              return `<span style="color: #ffffffe6;">${matchWord}</span>`;
            });
            return item;
          }
        );
        console.log("SearchCommunity", res, data.communityList);
      } catch (e) {
        console.error(e);
      }
    }, 100);

    // 在搜索时按下回车键
    const searchWhenKeyupEnter = () => {
      selectHotkey(data.searchIpt);
    };

    // 选中的关键词
    const selectHotkey = (keyWord: string) => {
      console.log("hotKey", keyWord);
      data.searchIpt = keyWord;
      data.selectKeyWord = keyWord;
      data.communityList.length = 0;
      // 此时需要去到游戏库
      router.push({
        name: "GameLibrary",
        query: {
          search: keyWord,
        },
      });
      // 重置滚动条
      window.scrollTo(0, 0);
    };

    // 清空输入框的数据
    const clearIpt = () => {
      data.isIptFocus = true;
      data.searchIptDom.focus();
      // 清空路由的search参数
      router.push({
        name: "GameLibrary",
        query: {},
      });
      data.communityList.length = 0;
      data.searchIpt = "";
      data.selectKeyWord = "";
    };

    watch(
      () => data.searchIpt,
      (newV: string) => {
        // 如果选中的关键字和新值一致则不进行搜索
        if (data.selectKeyWord && data.selectKeyWord === newV) return;
        searchByInput(newV);
      }
    );

    const navRefs: any = [];

    const setElementRef = (idx: number) => (el: any) => {
      navRefs[idx] = el;
    };
    const navLenObj = ref(new Map());
    const isInitPage = ref(true);
    onMounted(() => {
      document.body.onclick = (e: Event) => {
        if (!data.searchIptDom) return;
        if (!data.searchIptDom.contains(e.target)) {
          data.isIptFocus = false;
          data.communityList.length = 0;
        }
      };
      navRefs.forEach((el: any, idx: number) => {
        if (el) {
          navLenObj.value.set(idx, el.offsetWidth);
        }
      });
      console.log("navLenObj", navLenObj); // 初始的时候 根据它的索引定位
      // 初始的时候 以及 点击的时候根据索引的位置 计算滑动距离
    });

    //设置默认语言
    function findOptionByValue(
      options: CountryOption[],
      value: string
    ): CountryOption | undefined {
      return options.find((option: CountryOption) => option.value === value);
    }

    const defaultLang = findOptionByValue(countries.value, uselangStore().lang);

    const currentLanguage = ref(defaultLang?.label);

    const languageSelectOpen = ref(false);

    const isPageFirstOpen = ref(false);

    // 切换语言
    const selectLanguage = (lang: langObj) => {
      if (currentLanguage.value !== lang.label) {
        currentLanguage.value = lang.label;
        uselangStore().changeLang(lang.value);
      }
      languageSelectOpen.value = false;
    };

    watch(
      () => uselangStore().lang,
      (newLang, oldLang) => {
        nextTick(() => {
          navLenObj.value = new Map();
          navRefs.forEach((el: any, idx: number) => {
            if (el) {
              navLenObj.value.set(idx, el.offsetWidth);
            }
          });
          isInitPage.value = true;
          navTransLen.value = 0;
        });
      }
    );

    const turnVipPage = () => {
      trackCustomizeEvent({
        event_id: "chikii_web_vip_moudle_click",
      });
      router.push({ name: "VIP" });
    };
    return {
      golds,
      gems,
      navTabList,
      canShowSearchIpt,
      handleSearchIptFocus,
      router,
      route,
      ...toRefs(data),
      userInfo,
      vipExpireTime,
      isSignIn,
      changeNavTab,
      clearIpt,
      openRecharge,
      selectHotkey,
      searchWhenKeyupEnter,
      handlerLoginout,
      handlerLogin,
      formatDatetime,
      countries,
      languageSelectOpen,
      selectLanguage,
      currentLanguage,
      isPageFirstOpen,
      handleOpenPurchasedGame,
      turnVipPage,
      currentNav,
      setElementRef,
      navTransLen,
      isInitPage,
    };
  },
});
